// extracted by mini-css-extract-plugin
export default {"postConferenceBtn":"eZ5ZSiLXssjqtTVzoXtp","popoverFormats":"hUhzh7LkWshjjUHexZPt","format":"ruXWVziVzOAA27dCdEhi","pageTitle":"FxeiUl_Bx3iVkyULHp0o"};